<template>
  <div
    id="header--standard"
    class="header--standard header--standard-landing"
  >
    <div class="container">
      <div class="header--standard-wrap">
        <a
          href="#"
          class="logo"
        >
          <div class="title-block">
            <h6 class="logo-title">The Orangegirl V2</h6>
            <div class="sub-title">Home App</div>
          </div>
        </a>
      </div>
    </div>
  </div>
  <!-- ... end Header Standard Landing-->
</template>

<script>
export default {
  name: 'HeaderLanding',
  methods: {}
}
</script>
